import axios from 'axios';
import config from '../../config';

const getAxiosInstance = async () => {
    const instance = axios.create({
        baseURL: config.base_url,
        timeout: config.api_timeout,
        headers: {
            'APP_NAME': config.app_name,
            'APP_VERSION': config.app_version
        }
    });
    return instance;
}

async function getQueryStringFromObject(query = {}) {
    let queryString = '';
    for (let key in query) {
        if (query[key] === null || query[key] === undefined || query[key] === '') {
            continue;
        }
        query[key] = encodeURIComponent(query[key]);
        queryString += `${key}=${query[key]}&`;
    }
    return queryString;
}

export {
    getAxiosInstance,
    getQueryStringFromObject
}